module.exports = __webpack_public_path__ + "images/quiz-icon.4b934a78.webp";